export default __webpack_public_path__ + "static/media/mas-salagros-panoramic.8928a69d.jpg";